export interface CreateOrderValidationResponseDto {
  success: boolean;
  message?: string;
}
